import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const SIMaintenanceOverview = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance Overview</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<h2>MAINTENANCE OVERVIEW</h2>

							<p>This chapter discusses periodic inspection and adjustment tasks, which are necessary to maintain the equipment with the highest reliability.</p>
							<p>Sample tables of general preventive maintenance requirements have been included in the chapter for reference purposes. The tables are intended as a guideline and should not replace periodic maintenance schedules derived in the plant.</p>
							<div class="caution">
								<p>Before performing maintenance procedures, follow posted Lockout Procedures.</p>
							</div>
							<p>All machine parts wear with use. This wear usually results in a gradual increase of out-of tolerance conditions rather than sudden equipment failure. Preventive Maintenance (PM) must be performed on a regular basis to keep the equipment operating at peak efficiency.</p>
							<p>An established PM program is important because it results in increased reliability and longer equipment life. Such a program also results in the consistent manufacture of higher quality parts.</p>
							<p>The following information is provided to aid the maintenance personnel in maintaining and repairing the equipment.</p>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIMaintenanceOverview;
